export default __webpack_public_path__ + "static/media/y.929845ae.png";